/* eslint-disable react-refresh/only-export-components */
import { lazy } from "react"
import type { RouteObject } from "react-router-dom"

const AuthCallbackPage = lazy(() => import("./callback/AuthCallbackPage"))

export const authRoutes: RouteObject[] = [
  {
    path: "/auth/callback",
    element: <AuthCallbackPage />,
  },
]
